import styles from "./app-header-main.module.css"
import { NavLink, useLocation, useNavigate } from "react-router-dom"
import { useCallback, useEffect, useState } from "react"
import HeaderText from "../header-text/header-text"
import { useActiveButtonCountryTagChoice } from "../../services/context/CountryFilterContext"
import { useDispatch, useSelector } from "react-redux"
import { setAuthChecked, setUser } from "../../services/reducers/user-slice"
import { useMediaQuery } from "react-responsive"
import doorExit from "../../images/door-exit.svg"
function AppHeaderMain() {
  const [isMenuOpen, setIsMenuOpen] = useState(false)
  const isAuthChecked = useSelector((store) => store.user.isAuthChecked)
  const value = useActiveButtonCountryTagChoice()
  const dispatch = useDispatch()
  const navigate = useNavigate()
  const location = useLocation()
  // const history = useHistory()
  const onOpenPhone = () => {
    setIsMenuOpen(true)
  }

  const token = localStorage.getItem("token")

  const navigateProfile = useCallback(() => {
    if (!token) {
      navigate("/authorization")
    } else {
      navigate("/profile")
    }
  }, [])

  const logout = useCallback(() => {
    value.setPopUpExitVision((prev) => !prev)
    // localStorage.removeItem("token")
    // localStorage.removeItem("subscription")
    // dispatch(setUser(null))
    // dispatch(setAuthChecked(false))
    // window.location.reload()
  }, [])

  useEffect(() => {
    // Проверяем, есть ли токен в localStorage
    const token = localStorage.getItem("token")
    // Если токен есть, то isAuthChecked должно быть true
    if (token) {
      dispatch(setAuthChecked(true))
    } else {
      // Если токен нет, то isAuthChecked должно быть false
      dispatch(setAuthChecked(false))
    }
  }, [isAuthChecked])

  const isMobile = useMediaQuery({ query: "(max-width: 1024px)" })
  return (
    <header className={styles.header}>
      <div className={styles.container}>
        <NavLink to={"/"} className={styles.link}>
          <div className={styles.logo}></div>
        </NavLink>

        <ul className={styles.textContainer}>
          <li>
            <NavLink to={`/`} className={styles.link}>
              <button className={styles.buttonHeader}>
                <span className={styles.text}>Главная</span>
              </button>
            </NavLink>
          </li>
          <li>
            <NavLink to={`/analytics-and-news/`} className={styles.link}>
              <button className={styles.buttonHeader} type={"submit"}>
                <span className={styles.text}>Новости и аналитика</span>
              </button>
            </NavLink>
          </li>
          {/*
          <li>
            <NavLink to={"/products"} className={styles.link}>
              <button className={styles.buttonHeader}>
                <span id={"span"} className={styles.text}>Продукты</span>
              </button>
            </NavLink>
          </li>
           */}
          {/*
          <li>
            <NavLink to={"/info"} className={styles.link}>
              <button className={styles.buttonHeader}>
                <span className={styles.text}>Информационные страницы</span>
              </button>
            </NavLink>
          </li>
          */}
          <li>
            <NavLink to={"/education"} className={styles.link}>
              <button className={styles.buttonHeader}>
                <span className={styles.text}>Обучение</span>
              </button>
            </NavLink>
          </li>
          <li>
            <NavLink to={"/tables"} className={styles.link}>
              <button className={styles.buttonHeader}>
                <span className={styles.text}>Портфели</span>
              </button>
            </NavLink>
          </li>
          <li>
          <NavLink to={"/about-us"} className={styles.link}>
            <button className={styles.buttonHeader}>
              <span className={styles.text} style={{"white-space": "nowrap"}}>О нас</span>
            </button>
          </NavLink>
        </li>
          <li>
            <NavLink to={"/profile"} className={styles.link}>
              <button className={styles.buttonHeader}>
                <span className={styles.text}>Профиль</span>
              </button>
            </NavLink>
          </li>
        </ul>
        {isMobile || (
          <div className={styles.authorizationWrapper}>
            {location.pathname === "/authorization" ||
            location.pathname === "/noaccess" ? null : (
              <button
                onClick={() => {
                  value.toggleVisible(true)
                }}
                className={styles.earth}
              />
            )}
            {/*
            <button
              className={styles.profileButton}
              onClick={navigateProfile}
            />
            */}
            {/* Кнопка войти */}
            {location.pathname === "/authorization" ||
            location.pathname === "/noaccess" ? null : (
              <div
                className={styles.buttonWrapper}
                onClick={isAuthChecked ? logout : navigateProfile}
              >
                <div className={styles.doorExitWrapper}>
                  <img src={doorExit} className={styles.doorExit} />
                </div>
                <div className={styles.txtBtn}>
                  {isAuthChecked ? "Выйти" : "Войти"}
                </div>
              </div>
            )}
          </div>
        )}
        {/*
            <button
              onClick={isAuthChecked ? logout : onOpenModal}
              className={styles.authorization}
            >
              <div className={styles.authorizationTxt}>
              {isAuthChecked ? "Выход" : "Авторизация"}
              </div>
            </button>
            */}
      </div>

      {isMobile && (
        <div className={styles.buttonsBox}>
          {location.pathname === "/authorization" ||
          location.pathname === "/noaccess" ? null : (
            <button
              onClick={() => {
                value.toggleVisible(true)
              }}
              className={styles.earth}
            />
          )}
          {location.pathname === "/authorization" ||
          location.pathname === "/noaccess" ? null : (
            <button
              // className={isAuthChecked ? styles.buttonExit : styles.buttonAuth}
              className={styles.txtBtn}
              onClick={isAuthChecked ? logout : navigateProfile}
            >
            {isAuthChecked ? "Выйти" : "Войти"}
            
            
            
            
            </button>
          )}

          <button onClick={onOpenPhone} className={styles.menuButton}>
            {/*  <div className={styles.menu}></div>  */}
          </button>
        </div>
      )}
      {isMenuOpen && <HeaderText setIsMenuOpen={setIsMenuOpen} />}
    </header>
  )
}

export default AppHeaderMain
